import {ExpandMore} from '@mui/icons-material';
import {AccordionDetails, AccordionSummary} from '@mui/material';
import PropTypes from 'prop-types';

import EmmaiDentalOfficeForm from '../../../EmmaiDentalOfficeForm/EmmaiDentalOfficeForm';
import StyledAccordion from '../shared/StyledAccordion';
import StyledAccordionTitle from '../shared/StyledAccordionTitle';

const DentalOfficeAccordion = ({expanded, onChange}) => {
  return (
    <StyledAccordion expanded={expanded} onChange={onChange}>
      <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1-content" id="panel1-header">
        <StyledAccordionTitle>Infos permanentes cabinet</StyledAccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <EmmaiDentalOfficeForm />
      </AccordionDetails>
    </StyledAccordion>
  );
};

DentalOfficeAccordion.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DentalOfficeAccordion;
